export default {
  apiKey: 'AIzaSyACMDEi5uHh2ShlFMDctdPu5Km-E1VkHlY',
  authDomain: 'rickysquest-4dae6.firebaseapp.com',
  databaseURL: 'https://rickysquest-4dae6.firebaseio.com',
  projectId: 'rickysquest-4dae6',
  storageBucket: 'rickysquest-4dae6.appspot.com',
  messagingSenderId: '550824237675',
  appId: '1:550824237675:web:db3691604c63a621842f2e',
};
